import { memo as Memo, useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper'

//* Components
import Icon from 'components/common/Icon'

//* Styles
import CategoriesHorizontalSliderStyle from './style'

const CategoriesHorizontalSlider = Memo(({ className, children, activeIndex }) => {
    const sliderRef = useRef()

    //! Slide to active category
    useEffect(() => {
        if (typeof activeIndex === 'number' && sliderRef.current) {
            sliderRef.current.slideTo(activeIndex - 0.1)
        }
    }, [activeIndex])
    return (
        <CategoriesHorizontalSliderStyle className={`${className}-slider-container`}>
            <Swiper
                onSwiper={ref => sliderRef.current = ref}
                className={`${className}-slider`}
                slidesPerView={'auto'}
                shortSwipes={true}
                loopFillGroupWithBlank={true}
                freeMode={{
                    enabled: true,
                    freeModeMomentum: false,
                }}
                navigation={{
                    prevEl: `.${className}-action-btn-left`,
                    nextEl: `.${className}-action-btn-right`,
                }}
                modules={[FreeMode, Navigation]}
                scrollbar={{ draggable: true }}
            >
                {children.map((child, k) => {
                    return (
                        <SwiperSlide className={`${className}-slide`} key={k}>
                            {child}
                        </SwiperSlide>
                    )
                })}
            </Swiper>

            <span className={`${className}-action-btn-left action-btn-left action-btn primaryColor3-bg `}>
                <Icon name="arrow" />
            </span>

            <span className={`${className}-action-btn-right action-btn-right action-btn primaryColor3-bg `}>
                <Icon name="arrow" />
            </span>
        </CategoriesHorizontalSliderStyle>
    )
})

export default CategoriesHorizontalSlider